module.exports = __webpack_public_path__ + "static/media/icon-how-it-works5.fe4498a7.svg";